<div class="pageheader">
  <div class="page-title">
    <h1>Context properties</h1>
  </div>
</div>

@if (contextPropertyNamespaces().length > 0) {
  <div>
    <div>
      <p>
        Below you'll find a list of the system-context properties available in the current build of Link.
        These properties allow you to store and access data across different parts of the application, making it easier to share information throughout your integration flow.
      </p>
      <p>
        When working with code—especially when building assembly artifacts—we recommend using the <code>LinkPropertyAccessor</code> class.
        This gives you strongly typed access to context properties and helps make your code clearer and safer.
      </p>
      <p>Here’s a simple example of how to use <code>LinkPropertyAccessor</code>:</p>
      <pre>
        var propertyAccessor = new LinkPropertyAccessor(propertyBag);
      propertyAccessor.Document.DocumentNumber.Value = "1234567890";</pre>
    </div>
    <br />
    <table class="table table-sm table-striped font-monospace">
      <thead>
        <tr>
          <th>Area</th>
          <th>Namespace</th>
          <th>Property</th>
          <th>Type</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody style="font-family: monospace">
        @for (ns of contextPropertyNamespaces(); track ns) {
          <!-- Parent row -->
          <tr>
            <td><b>{{ trimName(ns.Name) }}</b></td>
            <td>{{ ns.Namespace }}</td>
            <td></td>
            <td></td>
            <td>{{ ns.Description }}</td>
          </tr>
          <!-- Property rows -->
          @for (prop of ns.Properties; track prop) {
            <tr>
              <td></td>
              <td></td>
              <td>{{ prop.Name }}</td>
              <td><span class="badge bg-badge text-white">{{ prop.Type }}</span></td>
              <td>{{ prop.Description }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
}
